import { IoMdTime } from "react-icons/io";
import { FaEnvelope, FaRedo } from 'react-icons/fa';
function TimelineItem(props: {
  current?: boolean | string;
  day: string;
  weekday: string;
  hours: string;
  title: string;
  mb?: string;
  email?:string
}) {
  const { current, day, weekday, hours, title, mb, email } = props;

  return (
    <div
      className={`flex w-full items-end justify-between gap-4 ${mb} rounded-xl p-1.5 ${
        current
          ? "bg-brand-900 dark:!bg-brand-400 "
          : "bg-white dark:!bg-navy-700"
      } `}
    >
      {/* left side */}
      <div className="flex items-center gap-3">
        <div
          className={`flex h-20 w-20 flex-col items-center justify-center rounded-xl ${
            current ? "bg-brand-900" : "bg-lightPrimary dark:!bg-navy-900"
          } `}
        >
          <p
            className={`text-sm font-bold ${
              current ? "text-white" : "text-gray-600 dark:text-white"
            } `}
          >
            {" "}
            {weekday}{" "}
          </p>
          <h5
            className={`text-[34px] font-bold ${
              current ? "text-white" : "text-navy-700 dark:text-white"
            } `}
          >
            {day}{" "}
          </h5>
        </div>
        <div className="flex flex-col" style={{ maxWidth: '200px' }}>
          <h5
            className={`text-base font-bold leading-6 ${
              current ? "text-white" : "text-navy-700 dark:text-white"
            } `}
          
          >
            {" "}
            {title}{" "}
          </h5>
          <h4
            className={`text-base  leading-6 ${
              current ? "text-white" : "text-navy-600 dark:text-white"
            } `}
          
          >
            {" "}
            {email}{" "}
          </h4>
          <div
            className={`mt-1 flex items-center gap-2 ${
              current ? "text-white" : "text-gray-600"
            } `}
          >
            <p className="">
              {" "}
              <IoMdTime />{" "}
            </p>
            <p className="text-sm font-bold"> {hours} </p>
          </div>
        </div>
      </div>
      {/* right */}
      <div className="flex h-full w-fit items-end justify-end pr-3 pb-2">
    
          {" "}
          <button className="your-button-class">
          <FaEnvelope />
          <FaRedo />
        </button>{" "}
    
      </div>
    </div>
  );
}

export default TimelineItem;
